// extracted by mini-css-extract-plugin
export default {"row":"createBundle_row__8HQbz","col":"createBundle_col__-MHYt","card":"createBundle_card__4ORe5"};